module.exports = __webpack_public_path__ + "dc65c8fac0a05f4a3d5eeb1eb7a531cb.svg";